// import Vue from 'vue'
import VueRouter from 'vue-router'
import local from '../utils/local.js'

const routes = [
	// 重定向
  {
		path: '/',
    redirect: '/login'
	},
  {
    path: '/login',
    name: 'Login',
		meta: {
			requireAuth: false,
			title: '登录 - 上海俊城达网络科技集团有限公司'
		},
    component: () => import("../views/Login.vue")
  },{
    path: '/riderInfo',
    name: 'RiderInfo',
		meta: {
			requireAuth: true,
			title: '骑手资源库 - 上海俊城达网络科技集团有限公司'
		},
    component: () => import("../views/RiderInfo.vue")
  }]

const router = new VueRouter({
	routes,
	mode: 'history',
})

router.beforeEach((to, from, next) => {
	document.title = `${to.meta.title}`;
	let userInfo = local.get('userInfo');
	let islogin = userInfo && userInfo.token
	console.log(islogin, 'islogin');
	if(to.path == "/login"){
		if(islogin){
			next("/riderInfo");
		}else{
			next();
		}
	}else{
		if(to.meta.requireAuth && islogin) {
			next();
		}else{
			next("/login");
		}
	}
})
export default router